import { useQuery } from '@tanstack/react-query'
import type { EntityChildDto } from 'api.gen'
import { entitiesControllerGetEntityChildren } from 'api.gen'
import { useUserInfo } from 'utils/hooks/use-userInfo'

function mapEntityChildDto(dto: EntityChildDto) {
  return {
    id: dto.id,
    name: dto.name,
    degree: dto.degree as unknown as string,
    type: dto.type
  }
}

export default function useEntityClasses({
  entityId,
  perPage = 100,
  shouldShowCurrentEntityIfEmpty = true
}: {
  entityId: number
  perPage?: number
  shouldShowCurrentEntityIfEmpty?: boolean
}) {
  const { data: classes, isLoading: loading } = useQuery({
    queryKey: ['entity-classes', entityId, perPage],
    queryFn: () => {
      return entitiesControllerGetEntityChildren({
        entityId,
        page: 1,
        perPage
      })
    },
    select: response => {
      return response?.data?.children || []
    }
  })

  const { user } = useUserInfo()

  if (
    shouldShowCurrentEntityIfEmpty &&
    Array.isArray(classes) &&
    classes.length === 0
  ) {
    const entity = user.reader.entity

    return {
      classes: [
        {
          id: entity.id,
          name: entity.name,
          degree: entity.degree,
          type: entity.type
        }
      ],
      loading
    }
  }

  return {
    classes: classes?.map(mapEntityChildDto) || [],
    loading
  }
}
